import React from "react";
import { useSelector, useDispatch } from "react-redux";
import "./Cart.css";
import { Button } from "@mui/material";
import { remove } from "../store/cartSlice";

const Cart = () => {
  let total = 0;
  const dispatch = useDispatch();
  const products = useSelector((state) => state.cart);
  const handleRemove = (productId) => {
    dispatch(remove(productId));
  };
  return (
    <div>
      <h1>Your Items</h1>
      {products.map((product) => {
        total += product.price;
        return (
          <div className="cartCard">
            <img src={product.image} alt="" />
            <h5>{product.title}</h5>
            <div
              className="p_rm"
              style={{
                display: "flex",
                gap: "5px",
                alignItems: "center",
              }}
            >
              <h5 style={{ color: "green" }}>${product.price}</h5>
              <Button
                variant="contained"
                className="btn"
                size="small"
                onClick={() => handleRemove(product.id)}
              >
                Remove
              </Button>
            </div>
          </div>
        );
      })}
      <p
        style={{
          textAlign: "right",
          paddingRight: "20px",
          color: "red",
          fontWeight: "bold",
        }}
      >
        Total amount: ${total.toFixed(2)}
      </p>
      <Button
        variant="contained"
        onClick={() => {
          if (total === 0) {
            alert("Please go to Home, and buy something first ");
            return;
          }

          alert(`payment of $${total} successful`);
          window.location.reload();
        }}
      >
        Pay
      </Button>
    </div>
  );
};

export default Cart;
